import React from "react";
import styled from "styled-components";
import ArticleCards from "components/molecures/ArticleCards";
import { UpdateArticleInput as Article, Category } from "API";
import { Link } from "gatsby";

type Props = {
  categoryArticles?: Article[];
  category?: Category | null;
};

const Title = styled.h2`
  color: #000000;
  font-size: 32px;
  padding-bottom: 8px;
  padding-top: 8px;
  width: 100%;
  font-weight: 800;
  opacity: 0.9;
`;

export default function ArticlesBox(props: Props) {
  const { categoryArticles, category } = props;

  return (
    <>
      {category && <Title>{category.name}</Title>}
      <ArticleCards
        articles={categoryArticles}
        showCategory={categoryArticles ? false : true}
      />
      {category && (
        <Link to={`/categories/${category.slug}`}>
          {category.name} の記事をもっと読む
        </Link>
      )}
    </>
  );
}
